import React from 'react'

import { Web3ReactProvider } from '@web3-react/core'
import { Web3Provider } from '@ethersproject/providers'

import './index.css'

import { ConnectWalletInterface, MigrationInterface } from './components'

import { ModalProvider, useModal } from './hooks'
import styled from 'styled-components'

function getLibrary(provider: any): Web3Provider {
  const library = new Web3Provider(provider)
  library.pollingInterval = 12000
  return library
}

export default function App() {
  return (
    <Web3ReactProvider getLibrary={getLibrary}>
      <ModalProvider>
        <Migration />
      </ModalProvider>
    </Web3ReactProvider>
  )
}

const Container = styled.div`
  display: flex;
  justify-content: column;
  align-items: center;
  height: 100vh;
`

function Migration() {
  const { currentModal } = useModal()
  return (
    <Container>
      {currentModal === 'connect' ? (
        <ConnectWalletInterface />
      ) : (
        <MigrationInterface />
      )}
    </Container>
  )
}
